var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.96 11.2359c0-.7357-.066-1.44304-.1886-2.12213h-9.7714v4.01323h5.5836c-.2405 1.2969-.9714 2.3957-2.0702 3.1314v2.6032h3.353c1.9618-1.8062 3.0936-4.466 3.0936-7.6257z",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.0001 21.3749c2.8013 0 5.1498-.929 6.8664-2.5135l-3.353-2.6032c-.9291.6225-2.1175.9903-3.5134.9903-2.7022 0-4.98942-1.825-5.80527-4.2773h-3.46619v2.6881c1.70716 3.3907 5.21579 5.7156 9.27146 5.7156z",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.19472 12.9713c-.2075-.6225-.3254-1.2875-.3254-1.9713s.1179-1.34873.3254-1.97123v-2.68807h-3.4662c-.72625 1.44576-1.10416 3.04139-1.103519 4.6593 0 1.6742.400849 3.2587 1.103519 4.6593z",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11.0001 4.75142c1.5233 0 2.8909.52347 3.9661 1.55153l2.9757-2.97573c-1.7967-1.67415-4.1453-2.70222-6.9418-2.70222-4.05567 0-7.5643 2.32494-9.27146 5.71568l3.46619 2.68807c.81585-2.45227 3.10307-4.27733 5.80527-4.27733z",
    fill: "#ea4335"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google.052aec1697156c9720f064388b07dc07.svg";